// @flow
import React from "react";
import styled from "styled-components";

const Item = styled.li`
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 5px;
  border: 1px solid transparent;
  color: ${({ theme }) => theme.palette.navy.medium};
  cursor: pointer;
  &:hover {
    background-color: ${({ theme }) => theme.palette.blue.extraLight};
    border: 1px solid ${({ theme }) => theme.palette.blue.medium};
  }
`;

const ErrorMessage = styled.li`
  padding: 10px;
  color: ${({ theme }) => theme.palette.navy.medium};
`;

type AddressWithPostcodeLatLon = {
  +__typename: "Address",
  +id: string,
  +label: string,
  +postcode: string,
  +town: string,
  postcodeLat: ?number,
  postcodeLon: ?number,
};

type Props = {
  postcodeValid: boolean,
  postcodeInServicedArea: boolean,
  addresses: $ReadOnlyArray<AddressPickerPostcodeDetails_postcodeDetails_addresses>, // eslint-disable-line
  onClick(address: AddressWithPostcodeLatLon): void,
  onPostcodeNotInServicedArea?: any,
  postcode: string,
  postcodeLat: ?number,
  postcodeLon: ?number,
};

const MenuItems = ({
  postcodeValid,
  postcodeInServicedArea,
  addresses,
  onClick,
  onPostcodeNotInServicedArea,
  postcode,
  postcodeLat,
  postcodeLon,
}: Props) => {
  if (!postcodeValid) {
    return (
      <ErrorMessage data-test="invalid-postcode">
        Please enter a valid postcode
      </ErrorMessage>
    );
  }

  if (!postcodeInServicedArea) {
    if (onPostcodeNotInServicedArea) {
      onPostcodeNotInServicedArea(postcode);
    } else {
      return (
        <ErrorMessage data-test="not-in-serviced-area">
          Sorry, we&apos;re not in your area yet!
        </ErrorMessage>
      );
    }
  }

  if (addresses.length === 0) {
    return (
      <ErrorMessage data-test="no-addresses">
        Sorry, we couldn&apos;t find any addresses for that postcode
      </ErrorMessage>
    );
  }

  return addresses.map<*>((address) => (
    <Item
      data-test="address-picker-menu-item"
      key={address.id}
      onClick={() => onClick({ ...address, postcodeLat, postcodeLon })}
    >
      {address.label}, {address.postcode}
    </Item>
  ));
};

export default MenuItems;
